import React, { useCallback, useContext } from 'react';
import { Button } from 'grommet';
import { ViewerEntitlementStatus } from '@components/Paywall/paywall.types';
import { analytics } from '@services/analytics';

import { UserContext } from '@services/Session';
import { usePaywallContext } from '@contexts/PaywallContext';
import { PaywallPageContext } from '@components/Paywall/paywall.types';

interface MonetizedViewButtonProps {
  handleActiveClip?: (activeClip: string, teamPlayerId: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clip: any;
  entitlementStatus: ViewerEntitlementStatus;
  teamId?: string;
  gameId?: string;
  activeClip?: (clip: unknown) => void;
  displayVideo?: (show: boolean) => void;
}

const MonetizedViewButton: React.FC<MonetizedViewButtonProps> = ({
  clip,
  gameId,
  activeClip = () => {},
  displayVideo = () => {},
  entitlementStatus = ViewerEntitlementStatus.NOT_ENTITLED_LOGGED_OUT,
}) => {
  const userStore = useContext(UserContext);
  const { handlePaywallOpen, setHandleTrayCTA } = usePaywallContext({
    entitlementStatus,
    trackingContext: PaywallPageContext.GAME_PAGE,
  });
  const handleViewClip = useCallback(
    () => {
      analytics.track('Game Page Clip Clicked', {
        gameId: gameId,
        clipId: clip.id,
        loggedIn: !!userStore.authUser,
        sport: 'vb',
      });
      switch (entitlementStatus) {
        case ViewerEntitlementStatus.NOT_ENTITLED_LOGGED_IN:
          handlePaywallOpen();
          break;
        case ViewerEntitlementStatus.NOT_ENTITLED_LOGGED_OUT:
          setHandleTrayCTA(true);
          break;
        case ViewerEntitlementStatus.ENTITLED:
          activeClip(clip);
          displayVideo(true);
          break;
        default:
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [entitlementStatus]
  );

  return (
    <>
      <Button
        plain
        color="secondary-2"
        label="View"
        onClick={() => {
          handleViewClip();
        }}
      />
    </>
  );
};
export default MonetizedViewButton;
